import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Paul Olle, Lausanne-based software engineer building React, Next.js, AI workflow, Three.js, and product engineering projects." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
